module.exports = __webpack_public_path__ + "static/media/docx.bc5f9db1.svg";